<template>
    <div>
      <el-form :inline="true" :model="searchForm">

        <el-form-item label="代理商名称：">
          <el-input v-model.trim="searchForm.agentName" placeholder="支持模糊搜索" @keyup.enter.native="getOldToNewListHandler"
            clearable></el-input>
        </el-form-item>
      <el-form-item label="余额低于：">
        <el-input v-model.trim="searchForm.amount" placeholder="池组余额低于多少元" @keyup.enter.native="getOldToNewListHandler"
          clearable></el-input>
      </el-form-item>
        <el-form-item class="btnArea">
          <el-button type="primary" @click="getOldToNewListHandler" plain icon="el-icon-search">搜索查询</el-button>
          <!-- <el-button type="success" plain icon="el-icon-download" @click="addStore()">新增池组</el-button> -->
        </el-form-item>
      </el-form>
  
      <el-table :data="tbpg.tableData" border>
        <el-table-column prop="name" label="代理名称" width="160" align="center"></el-table-column>
        <el-table-column prop="amountLog" label="充值总额（元）" align="center"></el-table-column>
        <el-table-column prop="amount" label="余额（元）" align="center"></el-table-column>
        <el-table-column prop="totalSim" label="总卡数" align="center"></el-table-column>
        <el-table-column prop="activeSim" label="已激活数" align="center"></el-table-column>
        <el-table-column prop="activingSim" label="本月在用" align="center"></el-table-column>
        <el-table-column prop="typeNmae" label="欠费操作" align="center"></el-table-column>
        <el-table-column prop="warnYu" label="告警余额" align="center"></el-table-column>
        <el-table-column prop="warnPhone" label="告警手机号" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-dropdown>
              <el-button type="success">
                代理操作
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="dataEdit(scope.row)"
                  style="color:black;font-weight :bold;">修改</el-dropdown-item>
                <el-dropdown-item @click.native="updateYu(scope.row)"
                  style="color:black;font-weight :bold;">余额管理</el-dropdown-item>
                <el-dropdown-item @click.native="selectYu(scope.row)" style="color:black;font-weight :bold;">余额流水</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="exportApplyHandler(scope.row)"
                  style="color:black;font-weight :bold;">导出卡板</el-dropdown-item> -->
                
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
  
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tbpg.currentPage"
        :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="tbpg.total">
      </el-pagination>
      <el-dialog :append-to-body="true" :title="title" :visible.sync="toNewCardVisible" width="1200px"
        :close-on-click-modal="false" @close="cancel">
        <el-form ref="toNewCardForm"  :model="toNewCardForm" label-width="120px">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="超套操作：" prop="type">
                <el-select v-model="toNewCardForm.type" clearable @input="change($event)">
                  <el-option v-for="(item, index) in storeStateList" :key="index" :label="item.label"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="剩余余额告警：" prop="warnYu">
                <el-input v-model="toNewCardForm.warnYu" placeholder="（选填）当余额低于多少元时，发送短信通知"
                  @input="change($event)"></el-input>
              </el-form-item>
            </el-col>
  
            <el-col :span="12">
              <el-form-item label="告警手机号：" prop="warnPhone">
                <el-input v-model="toNewCardForm.warnPhone" placeholder="（选填）多个手机号以-隔开 如1588886666-166888888"
                  @input="change($event)"></el-input>
              </el-form-item>
            </el-col>
  
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="sureToNewCardHandler">确 定</el-button>
        </div>
      </el-dialog>
  
  
  
  
      <el-dialog :append-to-body="true" title="流水记录" :visible.sync="actionLogVisible" width="1000px"
        :close-on-click-modal="false">
        <el-table :data="actionLogTbpg.tableData" border height="421">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="amount" label="交易金额"></el-table-column>
          <el-table-column prop="balance" label="交易余额"></el-table-column>
          <el-table-column prop="typeName" label="交易类型" width="100"></el-table-column>
          <el-table-column prop="remark" label="交易备注"></el-table-column>
          <el-table-column prop="createName" label="系统备注"></el-table-column>
          <el-table-column prop="createTime" label="交易时间" width="140"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
          :current-page="actionLogTbpg.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="actionLogTbpg.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="actionLogTbpg.total">
        </el-pagination>
        <span slot="footer" class="dialog-footer">
          <el-button @click="actionLogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
  
  
  
      <el-dialog :append-to-body="true" title="池组余额" :visible.sync="amountFlg" width="600px" @close="amountFlg = false"
        :close-on-click-modal="false">
        <el-form ref="amountData" :model="amountData" label-width="120px">
  
          <el-form-item label="交易类型:">
            <el-radio v-model="amountData.type" label="1">增加</el-radio>
            <el-radio v-model="amountData.type" label="0">扣减</el-radio>
          </el-form-item>
          <el-form-item label="交易金额：" prop="amount">
            <el-input-number v-model="amountData.amount" :precision="2" :step="1" :min="0">
            </el-input-number>
          </el-form-item>
  
          <el-form-item label="交易备注：">
            <el-input v-model="amountData.remark"></el-input>
          </el-form-item>
  
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="amountFlg = false">取 消</el-button>
          <el-button type="primary" @click="sureUpdate()">确 定</el-button>
        </div>
      </el-dialog>
  
  
    </div>
  </template>
  
  <script>
  import common from "@/utils/common.js";
  export default {
    data() {
      const validatorPhone = (rule, value, callback) => {
        if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error('代理商手机号有误，请重新输入。'))
        } else {
          callback()
        }
      }
      return {
        amountData: {
          id: '',
          amount: '',
          type: '',
          remark: ''
        },
        amountFlg: false,
  
  
        actionLogVisible: false,
        actionLogTbpg: {
          tableData: [],
          currentPage: 1,
          pageSize: 15,
          total: 0
        },
  
  
  
        agentListOption: [],
        searchForm: {
          name: "",
          storeType: "",
          // moveIds: [],
        },
        moveIdsList: [],
        storeStateList: [
          { label: '暂不操作', id: 0 },
          { label: '关停接口', id: 1 },
          { label: '卡板停机', id: 2}],
  
  
        poolTypeList: [
          { label: '无低消', id: '0' },
          { label: '单卡低消', id: '1' },
          { label: '共享低消', id: '2' }],
  
        addTypeList: [
          { label: '系统自动结余次月', id: '0' },
          { label: '人工手动结余', id: '1' }
        ],
  
  
        activeTypeList: [
          { label: '卡板首次激活', id: '0' },
          { label: '每月首次激活', id: '1' }
        ],
        title: '',
        tbpg: {
          tableData: [],
          currentPage: 1,
          pageSize: 15,
          total: 0,
        },
       
        branchSupplierOption: [],
        toNewCardVisible: false, //显示新增编辑弹窗
        toNewCardForm: {
          id: '',
          name: '',
          type: '',
          activePrice: '',
          supplierId: '',
          agentId: '',
          price: '',
          poolYa: '',
          poolType: '',
          minUse: '',
          stopPrice: '',
          outAddType: '',
          outAddData: '',
          warnPhone:'',
          warnYu:''
        },
        selectInfoId: '',
      };
    },
    created() {
      common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
      common.getAgentListOptionCom(this, 'agentListOption');
      this.getOldToNewListHandler();
    },
    methods: {
      handleSizeChanges(val) {
        this.actionLogTbpg.pageSize = val;
        this.selectYu();
      },
      handleCurrentChanges(val) {
        this.actionLogTbpg.currentPage = val
        this.selectYu();
      },
  
  
      exportApplyHandler(row) {
        var data = {
          id: row.id
        }
        this.$confirm('确定导出吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          common.sysRequest('export/poolSim', data, 'post').then(res => {
            if (res.data.code == 200) {
              this.$message.success('数据导出中,请稍候去任务中心下载');
            } else {
              this.$message.error(res.data.msg);
            }
          })
        }).catch(() => {
  
        });
      },
  
      updateYu(row) {
        this.amountData.id = row.id;
        this.amountData.type = '';
        this.amountData.amount = '';
        this.amountData.remark = '';
        this.amountFlg = true;
      },
      sureUpdate() {
        common.sysRequest('pool/update/amount/info', this.amountData, 'post').then(res => {
          if (res.data.code == 200) {
            this.$message.success("操作成功！")
            this.amountFlg = false;
            this.getOldToNewListHandler();
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
  
      selectYu(row, $event) {
        if (row && row.id) {
          this.selectInfoId = row.id;
        }
        common.resetCurrentPage(this, $event, 'actionLogTbpg');
        let data = common.getRequestParams(this, 'actionLogTbpg', { id: this.selectInfoId });
        common.sysRequest('pool/select/amount/info/agentId', data, 'post').then(res => {
          common.listCallback(this, res, 'actionLogTbpg');
          this.actionLogVisible = true;
        })
      },
      deletePool(id) {
        this.$confirm("删除后，数据会全部清空且无法恢复！您确定要进行删除操作吗？", "提示", {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          var data = {
            id: id
          }
          common.sysRequest('pool/delete/task', data, 'post').then(res => {
            if (res.data.code == 200) {
              this.$message.success("操作成功！")
              this.getOldToNewListHandler();
            } else {
              this.$message.error(res.data.message)
            }
          })
        })
      },
      cancel() {
        this.toNewCardVisible = false;
      },
      getOldToNewListHandler($event) {
        common.resetCurrentPage(this, $event, "tbpg");
        var data = common.getRequestParams(this, "tbpg", this.searchForm);
        common.sysRequest('pool//select/all/agent/acount', data, 'post').then(res => {
          common.listCallback(this, res, 'tbpg');
        })
      },
  
  
      addStore() {
        this.toNewCardVisible = true;
        this.toNewCardForm.id = ''
        this.title = '新增池组'
        this.$forceUpdate()
      },
      sureToNewCardHandler() {
        this.$refs['toNewCardForm'].validate((valid) => {
          if (valid) {
            common.sysRequest('pool/update/agent/warnPhone', this.toNewCardForm, 'post').then(res => {
                if (res.data.code == '200') {
                  this.cancel();
                  this.getOldToNewListHandler();
                  this.$message({ message: res.data.message, type: 'success', duration: 4000 })
                } else {
                  this.$message({ message: res.data.message, type: 'error', duration: 4000 })
                }
              })
          }
        })
      },
      dataEdit(data) {
        this.title = '编辑'
        this.toNewCardForm = data
        this.toNewCardForm.type = data.type;
        this.toNewCardVisible = true;
      },
      handleSizeChange(val) {
        this.tbpg.pageSize = val;
        this.getOldToNewListHandler();
      },
      handleCurrentChange(val) {
        this.tbpg.currentPage = val;
        this.getOldToNewListHandler();
      },
      change(e) {
        this.$forceUpdate()
      },
      addressChange(arr) {
  
      },
  
    }
  };
  </script>
  
  <style lang="less" scoped></style>
  